import React from 'react';
import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PageHeader from '../../../components/page-header';
import { FormPageFooter } from '../../../components/form-page-parts';
import PurchaseItemDataTable from './components/purchase-item-data-table';
import PurchaseFileDataTable from './components/purchase-file-data-table';
import { PurchaseGeneralForm } from './components/purchase-general-form';
import { usePurchaseCreateEditController } from './context/purchase-create-edit-controller';
import { usePurchaseCreateEditState } from './context/purchase-create-edit-context';
import { validatePurchase } from './context/purchase-validation';

const TAB_GENERAL = 0;
const TAB_ITEMS = 1;
const TAB_FILES = 2;

export function PurchaseCreateEditComponent() {
    const ctrl = usePurchaseCreateEditController();
    const { file, tabIndex1, purchaseRequest, purchaseId, showValidationErrors, itemsPurchaseJson } = usePurchaseCreateEditState();
    const errors = showValidationErrors ? validatePurchase(purchaseRequest, { isEdit: ctrl.isEdit, hasFile: !!file }) : {};

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title={ctrl.isEdit ? 'Editar Compra/Licitação' : 'Nova Compra/Licitação'}
                    subtitle={ctrl.isEdit ? 'Atualize as informações do processo de compra' : 'Cadastre um novo processo de aquisição ou licitação'}
                    breadcrumbs={[
                        { label: 'Compras e Licitações', href: '/compras-licitacoes' },
                        { label: ctrl.isEdit ? 'Editar' : 'Nova' },
                    ]}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column' }} elevation={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Tabs value={tabIndex1} onChange={ctrl.handleTabChange}>
                            <Tab label="Dados da Compra/Licitação" />
                            <Tab label="Itens" />
                            {ctrl.isEdit && <Tab label="Arquivos" />}
                        </Tabs>

                        <Box sx={{ height: tabIndex1 !== TAB_GENERAL ? '600px' : 'auto', display: 'flex', flexDirection: 'column' }}>
                            {tabIndex1 === TAB_GENERAL && (
                                <PurchaseGeneralForm errors={errors} onChange={ctrl.handleOnChange} onDateChange={ctrl.handleDateChange} onFileChange={ctrl.setFileUpload} />
                            )}
                            {tabIndex1 === TAB_ITEMS && (
                                <PurchaseItemDataTable
                                    purchaseId={purchaseId?.toString()}
                                    modalityId={purchaseRequest.modalityId}
                                    itemsPurchaseJson={itemsPurchaseJson}
                                    setItemsPurchaseJson={ctrl.setItemsPurchaseJson}
                                />
                            )}
                            {tabIndex1 === TAB_FILES && <PurchaseFileDataTable purchaseId={purchaseId?.toString()} />}
                        </Box>

                        <FormPageFooter onCancel={ctrl.navigateToList} onSave={ctrl.addOrEditPurchase} isSaving={ctrl.isSaving} />
                    </LocalizationProvider>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
